import { Suspense, lazy } from 'react';
import { Route } from 'react-router-dom';
import ApplicationSkeleton from '~/components/ApplicationSkeleton';

const EmergencyMode = lazy(() => import('~/containers/EmergencyMode'));

export default [
  <Route path="/emergency-mode" key="/emergency-mode">
    <Suspense fallback={<ApplicationSkeleton />}>
      <EmergencyMode />
    </Suspense>
  </Route>,
];
